module.exports = __webpack_public_path__ + "static/img/partner-costa.6da26f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-costa.png
// module id = Gwgv
// module chunks = 34